export async function fetchGoldUsd({
  gold = 'GLD',
  usdMode = 'auto',
  range = '5Y',
  includeCrossRead = true,
} = {}) {
  const params = new URLSearchParams({
    gold,
    usd_mode: usdMode,
    range,
    include_bars: '1',
    include_cross_read: includeCrossRead ? '1' : '0',
  });
  const response = await fetch(`/api/investing/gold-usd?${params}`);
  let body = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }
  if (!response.ok) {
    throw new Error(body?.error || `HTTP ${response.status}`);
  }
  return body;
}
